"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  Object.defineProperty(o, k2, {
    enumerable: true,
    get: function get() {
      return m[k];
    }
  });
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  }

  __setModuleDefault(result, mod);

  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(require("react"));

require("./Popover.css");

var classnames_1 = __importDefault(require("classnames"));

var icons_1 = require("@tiendanube/icons");

var __1 = require("..");

function Popover(_a) {
  var name = _a.name,
      label = _a.label,
      title = _a.title,
      children = _a.children,
      menu = _a.menu,
      _b = _a.position,
      position = _b === void 0 ? "left" : _b;

  var _c = React.useState(false),
      active = _c[0],
      setActive = _c[1];

  var className = classnames_1.default("nimbus--popover-wrapper", {
    "position--right": position === "right"
  });
  var renderTitle = title && React.createElement("div", {
    className: "nimbus--popover-header"
  }, React.createElement(__1.Title, {
    type: "h5"
  }, title));
  var renderActive = active && React.createElement("div", {
    id: "nimbus-popover-wrapper-" + name,
    className: className,
    role: "dialog",
    onTouchStart: function onTouchStart(event) {
      event.stopPropagation();
    },
    onClick: function onClick(event) {
      event.stopPropagation();
    }
  }, renderTitle, React.createElement("div", {
    className: "nimbus--popover-body"
  }, menu ? React.createElement("ul", {
    className: "nimbus--popover-menu"
  }, menu.map(function (option, index) {
    return option !== "skeleton" ? React.createElement("li", {
      key: index,
      className: "nimbus--popover-menu__item"
    }, React.createElement(__1.Link, {
      onClick: function onClick() {
        var _a;

        (_a = option.onClick) === null || _a === void 0 ? void 0 : _a.call(option);
        setActive(false);
      },
      icon: option.icon,
      appearance: option.appearance
    }, option.children)) : React.createElement(__1.Link.Skeleton, {
      key: index
    });
  })) : children));

  var handleClick = function handleClick() {
    setActive(function (currentActive) {
      return !currentActive;
    });
  };

  var getTagFromEvent = function getTagFromEvent(target) {
    return target.tagName.toLocaleLowerCase();
  };

  var handleClickOnDiv = function handleClickOnDiv(event) {
    var tag = getTagFromEvent(event.target);
    if (tag === "div") setActive(function () {
      return false;
    });
  };

  var handleTouchOnDiv = function handleTouchOnDiv(event) {
    switch (getTagFromEvent(event.target)) {
      case "div":
        setActive(function () {
          return false;
        });
        break;

      case "a":
        event.stopPropagation();
        break;

      case "svg":
        event.stopPropagation();
        break;

      default:
    }
  };

  var handleClickGlobal = React.useCallback(function (event) {
    var clickOnInside = false;
    var clickOnInitiator = false;
    event.composedPath().forEach(function (el) {
      var currentClassName = el.className || "";

      if (currentClassName.toString().indexOf("nimbus--popover-wrapper") >= 0) {
        clickOnInside = true;
      }

      if (el.id === "nimbus-popover-initiator-" + name) {
        clickOnInitiator = true;
      }
    });

    if (!clickOnInitiator && !clickOnInside) {
      setActive(false);
    }
  }, [name]);
  React.useEffect(function () {
    if (active) {
      document.addEventListener("click", handleClickGlobal, false);
      document.addEventListener("touchstart", handleClickGlobal, false);
    } else {
      document.removeEventListener("click", handleClickGlobal, false);
      document.removeEventListener("touchstart", handleClickGlobal, false);
    }

    return function () {
      document.removeEventListener("click", handleClickGlobal, false);
      document.removeEventListener("touchstart", handleClickGlobal, false);
    };
  }, [active, handleClickGlobal]);
  return React.createElement("div", {
    id: "nimbus-popover-" + name,
    className: "nimbus--popover",
    role: "presentation",
    onClick: handleClickOnDiv,
    onTouchStart: handleTouchOnDiv
  }, React.createElement("div", {
    id: "nimbus-popover-initiator-" + name
  }, menu ? React.createElement(__1.Link, {
    icon: icons_1.EllipsisIcon,
    iconSize: "medium",
    appearance: "secondary",
    onClick: handleClick
  }) : React.createElement(__1.Link, {
    icon: active ? icons_1.ChevronUpIcon : icons_1.ChevronDownIcon,
    iconPosition: "end",
    appearance: "default",
    onClick: handleClick
  }, label)), renderActive);
}

var Skeleton = function Skeleton() {
  return React.createElement("div", {
    className: "nimbus--popover-skeleton"
  });
};

Popover.Skeleton = Skeleton;
exports.default = Popover;